<template>
  <header class="site-header">
    <div class="site-header__inner">
      <router-link to="/" class="brand" @click="closeMenu">
        <img src="../assets/logo-afm.gif" class="brand__logo" alt="AfM" />
        <span class="brand__text">
          <strong>AfM</strong>
          <small v-if="sprachID === 0">Arbeitskreis für Mammillarienfreunde</small>
          <small v-else>Society for Mammillaria enthusiasts</small>
        </span>
      </router-link>

      <div class="site-header__actions">
        <button class="language-switch" type="button" @click="changeSprache(sprachID === 0 ? 1 : 0)" :aria-label="sprachID === 0 ? 'Switch to English' : 'Auf Deutsch wechseln'">
          <img v-if="sprachID === 0" src="../assets/vereinigte-staaten.png" alt="English" />
          <img v-else src="../assets/deutschland.png" alt="Deutsch" />
          <span>{{ sprachID === 0 ? 'EN' : 'DE' }}</span>
        </button>
        <button class="menu-toggle" type="button" :class="{ 'is-open': menuOpen }" @click="menuOpen = !menuOpen" :aria-expanded="menuOpen ? 'true' : 'false'" aria-label="Menü öffnen oder schließen">
          <span></span><span></span><span></span>
        </button>
      </div>

      <nav class="main-nav" :class="{ 'is-open': menuOpen }" aria-label="Hauptnavigation">
        <router-link v-for="item in navItems" :key="item.to" :to="item.to" class="main-nav__link" :class="{ 'is-active': isActive(item.to) }" @click="closeMenu">
          {{ sprachID === 0 ? item.de : item.en }}
        </router-link>
      </nav>
    </div>
  </header>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "TheNavbar",
  data() {
    return {
      menuOpen: false,
      navItems: [
        { to: "/", de: "Start", en: "Home" },
        { to: "/Verein", de: "Verein", en: "Association" },
        { to: "/Medien", de: "Medien", en: "Media" },
        { to: "/Galerie", de: "Fotogalerie", en: "Photo gallery" },
        { to: "/Redaktionen", de: "Redaktionen", en: "Editorial offices" },
        { to: "/Veranstaltungen", de: "Veranstaltungen", en: "Events" },
        { to: "/Shop", de: "Shop", en: "Shop" },
        { to: "/Kontakt", de: "Kontakt", en: "Contact" },
        { to: "/Sonstiges", de: "Sonstiges", en: "Other" },
      ],
    };
  },
  computed: {
    ...mapGetters({ activeScreen: "getActiveSite" }),
    sprachID() {
      return this.$store.getters.getSprachID;
    },
  },
  watch: {
    "$route.path"() {
      this.closeMenu();
    },
  },
  methods: {
    isActive(path) {
      if (path === "/") return this.$route.path === "/";
      return this.$route.path === path || this.$route.path.startsWith(path + "/");
    },
    closeMenu() {
      this.menuOpen = false;
    },
    changeSprache(sprachwert) {
      this.$store.dispatch("setSprachID", sprachwert);
    },
  },
};
</script>
